<template>
  <div class="library-cloud-settings" :class="{ 'is-apple': apple, 'is-salt': salt }" aria-label="音乐库索引保存">
    <component v-if="apple || salt" :is="rowComponent" :title="'索引保存位置'" :description="description">
      <template v-if="salt" #trailing><SaltSelect aria-label="音乐库索引保存位置" :value="cloud.mode" @change="setMode"><option value="local">本地浏览器</option><option value="cloud" :disabled="!account.user">本地与云端账号</option></SaltSelect></template>
      <component v-else :is="apple ? 'AppleSelect' : 'select'" aria-label="音乐库索引保存位置" :value="cloud.mode" @change="setMode"><option value="local">本地浏览器</option><option value="cloud" :disabled="!account.user">本地与云端账号</option></component>
    </component>
    <div v-else class="item"><div class="left"><label class="title" :for="'library-cloud-location-' + _uid">索引保存位置</label><div class="description">{{ description }}</div></div><div class="right"><select :id="'library-cloud-location-' + _uid" aria-label="音乐库索引保存位置" :value="cloud.mode" @change="setMode"><option value="local">本地浏览器</option><option value="cloud" :disabled="!account.user">本地与云端账号</option></select></div></div>
    <div class="library-cloud-status" aria-live="polite">
      <router-link v-if="!account.user" to="/account">登录本站账号后可开启云端保存</router-link>
      <template v-else-if="cloud.mode === 'cloud'">
        <span>{{ statusText }} · {{ cloud.bytes > 0 ? (cloud.bytes / 1024).toFixed(1) + ' KiB / 1 MiB' : '上限 1 MiB' }}</span>
        <div v-if="cloud.status === 'conflict'" class="library-cloud-actions"><component :is="buttonComponent" variant="subtle" style-type="subtle" @click="mergeCloud">合并云端索引</component><component :is="buttonComponent" variant="plain" style-type="subtle" @click="keepLocal">以本地版本保存</component></div>
        <component v-else-if="['error', 'signed-out'].includes(cloud.status)" :is="buttonComponent" variant="plain" style-type="subtle" @click="retry">重试同步</component>
        <p v-if="cloud.error" role="status">{{ cloud.error }}</p>
      </template>
    </div>
  </div>
</template>
<script>
import { libraryCloudSync } from '../library-cloud-integration';
import { siteAccount } from '../site-account';
import AppleSettingRow from '../apple/ui/AppleSettingRow.vue';
import AppleSelect from '../apple/ui/AppleSelect.vue';
import AppleButton from '../apple/ui/AppleButton.vue';
import SaltItem from '../salt/ui/SaltItem.vue';
import SaltSelect from '../salt/ui/SaltSelect.vue';
import SaltButton from '../salt/ui/SaltButton.vue';
export default {
  name: 'LibraryCloudSettings',
  components: { AppleSettingRow, AppleSelect, AppleButton, SaltItem, SaltSelect, SaltButton },
  props: { apple: Boolean, salt: Boolean },
  data: () => ({ cloud: libraryCloudSync.state, account: siteAccount }),
  computed: {
    rowComponent() { return this.salt ? 'SaltItem' : this.apple ? 'AppleSettingRow' : 'div'; },
    buttonComponent() { return this.salt ? 'SaltButton' : this.apple ? 'AppleButton' : 'button'; },
    description() { return this.cloud.mode === 'cloud' ? '同步索引与歌词，原始音频保存在本地' : '默认仅保存到此浏览器'; },
    statusText() { return { local: '仅本地保存', checking: '正在核对云端版本', pending: '等待同步', syncing: '正在保存云端', synced: '已同步', conflict: '版本不同，等待选择', error: '同步失败，本地保留', 'signed-out': '账号已失效，本地保留' }[this.cloud.status]; },
  },
  methods: {
    setMode(event) { return libraryCloudSync.setMode(event?.target?.value || event); },
    retry() { return libraryCloudSync.retry(); },
    mergeCloud() { return libraryCloudSync.useCloud(); },
    keepLocal() { return libraryCloudSync.keepLocal(); },
  },
};
</script>
<style scoped>
.library-cloud-settings { min-width:0; }
.library-cloud-settings.is-apple ::v-deep .apple-ui-setting-control { flex:0 0 auto; max-width:none; }
.library-cloud-status { display:flex; align-items:center; flex-wrap:wrap; gap:6px 12px; color:var(--apple-ui-muted,var(--color-secondary)); font-size:11px; line-height:1.5; overflow-wrap:anywhere; }
.library-cloud-status:empty { display:none; }
.library-cloud-status:not(:empty) { padding:4px 0 9px; }
.library-cloud-status a { color:var(--apple-ui-accent,var(--color-primary)); text-decoration:none; }
.library-cloud-status p { flex-basis:100%; margin:0; }
.library-cloud-actions { display:flex; flex-wrap:wrap; gap:6px; }
.library-cloud-settings:not(.is-apple):not(.is-salt) { padding:12px 0; }
</style>
